import { ReduxStore } from 'store/types';

function getSearchedInterventionErrorMsg(state: ReduxStore): string {
  return state.intervention.getSearchedIntervention.config.errorMsg;
}

export default getSearchedInterventionErrorMsg;
